import {
    VISIT1_IS_EDITED,
    VISIT1_IS_ERROR,
    VISIT1_IS_GET,
    VISIT1_IS_LOADING
} from '../../actions/visit1/visit1Action';

const initialData = {
    isLoading: false,
    isError: false,
    formData: null,
    initialData: null
};

export function visit1Reducer(state = initialData, action){
    switch (action.type) {
        case VISIT1_IS_LOADING:
            return {...state, isLoading: true, isError: false};
        case VISIT1_IS_ERROR:
            return {...state, isLoading: false, isError: true};
        case VISIT1_IS_GET:
            return {...state, isLoading: false, isError: false, initialData: action.payload, formData: action.formData};
        case VISIT1_IS_EDITED:
            return {...state, isLoading: false, isError: false, formData: action.payload };
        default:
            return state;
    }
}
